if (!customElements.get('tabbed-products')) {
  class TabbedProducts extends HTMLElement {
    constructor() {
      super();
      this.activeTab = '';
      this.tabs = this.querySelectorAll('.home-machine-list-customize__tab');
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.showTab(tab));
        if (index === 0) {
          this.showTab(tab);
        }
      });
    }

    showTab(tab) {
      if (!tab) return;
      const tabName = tab.dataset.tab;
      if (this.activeTab === tabName) {
        return;
      }
      let elems = this.querySelectorAll('[data-tab="' + this.activeTab + '"]');
      elems.forEach((elem) => {
        elem.classList.remove('active-tab');
      });
      elems = this.querySelectorAll('[data-tab="' + tabName + '"]');
      elems.forEach((elem) => {
        elem.classList.add('active-tab');
      });
      this.activeTab = tabName;
    }
  }

  customElements.define('tabbed-products', TabbedProducts);
}